import { DiscountsHomeQueryOutput } from "../queries"

const blockTypeHasOffer = [
  'featuredOffer',
  'collectionGrid',
  'featuredOffers',
  'forYou',
  'offerCollection',
  'offerGrid',
]

export const dedupeDiscountsIds = (discountsData: DiscountsHomeQueryOutput['DiscountsHome']['content']) => {
  const dedupeIds = discountsData
    .filter((content) => blockTypeHasOffer.includes(content.blockType))
    .reduce((acc, curr) => {
      if ('offers' in curr) {
        const offers = curr.offers as any[]

        return [...acc, ...offers.map((offer) => offer.id)]
      }
      return [...acc, curr.id]
    }, [] as string[])

  return dedupeIds
}